module.exports = __webpack_public_path__ + "img/Imaginative Mind.77e85e9a.svg";